import { ScenarioPage, ScenarioPageProps } from '../components/Page';
import useEntryTrack from '../hooks/useEntryTrack';
import { getRouteAccess } from '../Scenario/config';
import createRoute from '../Scenario/createRoute';

export const reviewRouteAccess = getRouteAccess('配置评价管理任务');

const pageRoute = createRoute('review');

export const route: ScenarioPageProps['route'] = {
  ...pageRoute,
  element: <Review />,
  access: reviewRouteAccess,
};

function Review() {
  useEntryTrack('aide/review');

  return <ScenarioPage route={pageRoute} />;
}

export default Review;
